import { useState } from "react";
import { Input } from "semantic-ui-react";
import ManageTeam from "../components/sidekick/teams/ManageTeam";
import { Field, Page, PageHeader } from "../components/ui";

function AddTeam() {
  const [teamName, setTeamName] = useState("");
  const [errors, setErrors] = useState({});

  return (
    <Page>
      <PageHeader
        back={{ to: "/admin/teams", label: "Teams" }}
        title="Add Team"
      />

      <Field
        label="Team name"
        htmlFor="team-name"
        error={errors.name}
        style={{ maxWidth: "300px" }}
      >
        <Input
          id="team-name"
          placeholder="Team name"
          error={"name" in errors}
          onChange={(e) => setTeamName(e.target.value)}
        />
      </Field>
      <ManageTeam
        data={{ id: "", name: teamName, members: [] }}
        createTeam
        setTeamNameError={setErrors}
      />
    </Page>
  );
}

export default AddTeam;
